import { useContext, useMemo } from 'react';

import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import {
  ColSize,
  ContentSection,
  Form,
  InputNumberForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { QUOTATION_BUTTON } from '../../../../../shared';

import { GenericDataFormContext } from '../../../../../shared/contexts';
import { StepFourFormContext } from '../../contexts/StepFourForm';

import { COLORS } from '../../../../../../../../../config/themes/colors';

export const FirePaymentMethods = () => {
  const { paymentMethods } = useContext(GenericDataFormContext);

  const {
    firePaymentMethodsForm,
    commertialConditions,
    setLabelButton,
    clearPrimaFieldsOnFormChange,
  } = useContext(StepFourFormContext);

  const maxVariation = useMemo(
    () => commertialConditions?.puntosDeAumentoExtraPrimaVariable!,
    [commertialConditions]
  );
  const minVariation = useMemo(
    () => -commertialConditions?.puntosDeDisminucionExtraPrimaVariable!,
    [commertialConditions]
  );

  const prevValues = useMemo(
    () => ({
      prevEPVValue: commertialConditions?.porcentajeExtraPrimaVariable,
      prevCommissionValue: commertialConditions?.porcentajeDeComision,
    }),
    [commertialConditions]
  );

  //* on change variation set epv and commission value, and set state for requote.
  const onPaymentsMethodFormChange = (valueChanged: { variation: number }) => {
    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    clearPrimaFieldsOnFormChange();

    if (valueChanged?.variation?.toString().length) {
      const prevCommissionValue = Number(prevValues.prevCommissionValue);
      const prevEPVValue = Number(prevValues.prevEPVValue);

      if (prevCommissionValue !== undefined && prevEPVValue !== undefined) {
        firePaymentMethodsForm.setFieldValue(
          'extraVariable',
          prevEPVValue + valueChanged.variation
        );
        firePaymentMethodsForm.setFieldValue(
          'commission',
          prevCommissionValue + valueChanged.variation
        );
      }
    }
  };

  return (
    <Form
      formProps={{
        form: firePaymentMethodsForm,
        name: 'fire-payment-methods-form',
        onValuesChange: onPaymentsMethodFormChange,
      }}
    >
      <ContentSection level='h3' title='Forma de pago y comisiones'>
        <RowSize>
          <ColSize size={20}>
            <SelectForm
              formProps={{
                label: 'Forma de pago:',
                name: 'paymentMethod',
              }}
              selectProps={{
                options: paymentMethods,
                style: { backgroundColor: COLORS.neutrals[0] },
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Comisión:',
                name: 'commission',
              }}
              inputNumberProps={{
                disabled: true,
                precision: 2,
                readOnly: true,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Extra prima variable:',
                name: 'extraVariable',
              }}
              inputNumberProps={{
                disabled: true,
                precision: 2,
                readOnly: true,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                initialValue: 0,
                label: 'Variación:',
                name: 'variation',
              }}
              inputNumberProps={{
                controls: {
                  upIcon: <PlusOutlined />,
                  downIcon: <MinusOutlined />,
                },
                addonAfter: '%',
                max: maxVariation,
                min: minVariation,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>
    </Form>
  );
};
